export default {
    // 公共
    c: {
        input: '请输入',
        select: '请选择',
        please: '请',

        operation: '操作',
        tip: '提示',
        login: '登录',
        logout: '登出',
        search: '搜索',
        export: '导出',
        add: '新增',
        edit: '编辑',
        cancel: '取消',
        confirm: '确定',
        detail: '详情',
        delete: '删除',
        refresh: '刷新',
        view: '查看',
        start: '开始',
        pause: '暂停',
        stop: '停止',
        quit: '终止',
        remove: '移出',
        check_all: '全选',
        clear_all: '全不选',
        generate: '生成',
        close: '关闭',
        open: '开启',
        parse: '解码',
        reset: '重置',

        unknown: '未知',
        user: '用户',
        data: '数据',
        content: '内容',
        coordinate: '经纬度',
        longitude: '经度',
        latitude: '纬度',
        create_time: '创建时间',
        begin_time: '开始时间',
        end_time: '结束时间',
        status: '状态',
        type: '类型',
        task: '任务',
        target: '目标',
        setting: '设置',

        select_user: '选择用户',
        select_device: '选择设备',

        oper_success: '操作成功',
        oper_failure: '操作失败',
        upload_failure: '上传失败',
        upload_success: '上传成功',
    },
    unit: {
        meter: '米',
        ms: '毫秒',
        byte: '字节',
        day: '天',
    },
    tip: {
        welcome: '你好！欢迎使用HORWIN IOT平台',

        please_login: '请先登录',

        ask_logout: '确定要登出系统吗？',

        no_identity: '当前身份无法访问'
    },
    title: {
        overview: '数据总览',
        device_management: '设备管理',
        vehicle_26001: '车辆-26001',
        vehicle_26003: '车辆-26003',
        vehicle_26004: '车辆-26004',
        vehicle_26007: '车辆-26007',
        bms_26005: 'BMS-26005',
        bms_26006: 'BMS-26006',
        vehicle_detail: '车辆详情',
        bms_detail: 'BMS详情',
        OTA: 'OTA',
        task_list: '任务列表',
        task_detail: '任务详情',

        user_management: '用户管理',
        user_list: '用户列表',
        user_detail: '用户详情',

        admin_management: '管理员',
        admin_list: '管理员列表',
        admin_detail: '管理员详情',

        tool_management: '工具',
        parser_26005: '26005-解码',
    },

    // 账号
    user: {
        auth: '权限',
        admin: '管理员',
        client: '普通用户',
        username: '用户名',
        password: '密码',
        ask_delete_title: '确定要删除该用户吗？',
        ask_delete_content: '删除用户后，平台上该用户的所有数据将清除。',

        notify_url: '推送地址',
        addr: '路由地址',
        addr_extra: '自定义配置',
        addr_profile: '路由自定义配置',
        addr_config: '路由预定义配置',
        relay_mqtt_enable: 'MQTT推送',

        tip_configure_current: '请先配置好当前的路由信息',
        tip_address_exists: '路由地址已存在',
        tip_format_error: '路由地址格式不正确',
        tip_type_exists: '该类型已配置',
    },
    // 首页
    home: {
        device_stat: '设备统计',
        device_count: '接入设备总数',
        device_online_count: '在线设备数',
        device_offline_count: '离线设备数',
        device_warning_count: '告警设备数',
    },


    // 设备
    device: {
        device: '设备',
        device_uid: '设备UID',
        last_active_time: '最后活动时间',

        online_status: '在线状态',
        status: {
            all: '全部',
            online: '在线',
            offline: '离线',
        },

        device_space: '设备类型',
        space: {
            "26001": "车辆-26001",
            "26003": "车辆-26003",
            "26004": "车辆-26004",
            "26007": "车辆-26007",
            "26005": "BMS-26005",
            "26006": "BMS-26006",
        },
        vehicle: '车辆',

        distribute: '分配',
        distributed: '已分配',
        no_distribute: '尚未分配',
        expire_time: '过期时间',

        clear_cache: '清除缓存',
        clear_cache_ask: '确定清除该设备的路由缓存吗？',
        export_ask: '确定要导出吗？',

        DeviceInfo: "设备信息",
        EventList: "设备事件",
        FrameList: "上行数据",
        CommandList: "下行命令",
        RelayLog: "推送记录",


        base_info: '基本信息',
        imsi:'IMSI',
        imei:'IMEI',
        iccid:'ICCID',
        latitude:'纬度',
        longitude:'经度',
        speed:'速度',
        angle: '角度',
        navigate:'运动方向',
        last_gps_report_time:'最后定位状态上报时间',
        gsm_signal_strength:'GSM信号强度',
        gps_signal_strength:'GPS信号强度',
        gps_state:'GPS定位状态',
        voltage:'电压',
        current:'电流',
        soc:'SOC',
        temperature_sensor: '温度传感器',
        temperature:'温度',
        remaining_capacity:'剩余容量',
        full_charge_capacity:'充满容量',
        cycle_count:'循环次数',
        rated_capacity:'额定容量',
        rated_voltage:'额定电压',
        version:'版本',
        manufacture_date:'生产时间',
        manufacture_name:'制造商',
        name:'名称',
        chem_id:'电芯型号',
        dtu_software_version:'DTU版本',
        bms_software_version:'BMS版本',
        bluetooth_mac:'蓝牙MAC',
        last_active_time:'活跃时间',
        location:'位置',
        BMS:'BMS',
        DTU:'DTU',
        gnss_satellite_used_count:'GNSS卫星数量',
        gprs_apn: "GPRS APN",
        gprs_total_data_used:'GPRS数据使用量',
        gps_satellite_in_view_count:' GPS可见卫星数量',
        iot_temperature:'DTU模块温度',
        bms_bar_code:'BMS条码',
        bms_id:'BMS ID',
        low_cell_voltage: '低16节电压数据',
        high_cell_voltage: '高16节电压数据',
        battery_most_value_log: '电池最值',
        error_count: '错误计数',
        battery_status: '电池状态',
        bluetooth_password: '蓝牙连接密码',
        gprs_stat: 'GPRS数据量统计',

        module_access_parameters: '模块接入参数',
        server_addr: '服务端地址',
        OM_server_addr: '运维服务器地址',
        activate_module_upgrade: '激活模块升级',
        module_upgrade: '模块升级',
        bms_upgrade: 'BMS 升级',
        set_battery: '配置电池',
        electronic_fence: '电子围栏',
        fence_radius: '围栏半径',

        bms_count: 'BMS个数',
        bms_1_sn: 'BMS1序列号',
        bms_2_sn: 'BMS2序列号',
        charge_count: '充电次数',
        discharge_count: '放电次数',
        max_temperature: '最高温度',


        vcu_version: 'VCU版本',

        bms_version: 'BMS版本',

        ota_result: 'OTA结果',
        ota_version: 'OTA版本',
        ota_id: 'OTA ID',

        location_status: '定位状态',
        location_north_south: '南北半球',
        location_east_west: '东西半球',
        location_longitude: '经度',
        location_latitude: '纬度',
        location_speed: '定位速度',
        location_angle: '定位角度',
        location_satellite_count: '卫星个数',
        location_coordinate: "坐标",
        location_direction: "方向",
        location_type: "定位来源",
        location_valid: "定位有效性",
        location_altitude: "定位海拔",

        max_speed: '上锁后最高时速',

        battery_status: '充电状态',
        vcu_soc: 'VCU电量',
        battery_soc: '电池电量',
        battery_temperature: '电池温度',
        battery_cycle_count: '循环次数',
        battery_charge_remaining_time: '充电剩余时长',

        guard_alarm_status: '防盗报警状态',

        warning: '异常信息',

        lock_result: '锁车状态',

        bms_config_set_result: 'BMS参数设置反馈',

        check_vcu_mode: '检测-VCU工作模式',
        check_vcu_error: '检测-VCU故障',
        check_mcu_mode: '检测-MCU模式',
        check_mcu_error: '检测-MCU故障',
        check_bms_1_mode: '检测-BMS1模式',
        check_bms_1_error: '检测- BMS1故障',
        check_bms_2_mode: '检测-BMS2模式',
        check_bms_2_error: '检测-BMS2故障',
        check_hmi_mode: '检测-HMI模式',
        check_bc_error: '检测-BC故障',

        heartbeat_interval: '心跳周期',

        server_addr: '服务器地址',

        locate_interval_acc_on: 'ACC ON 定位上报周期',
        locate_interval_acc_off: 'ACC OFF定位上报周期',
        target_type:'子设备类型',

        rear_wheel_speed_ratio: '后轮转速系数',
        front_wheel_speed_ratio: '前轮转速系数',
        drive_ratio: '转动系数',
        remaining_mileage_ratio: '剩余里程系数',
        cut_off_voltage_threshold: '截止电压',
        over_voltage_protect_threshold: '过压保护',
        over_current_protect_threshold: '限流保护',
        leak_voltage_protect_threshold: '欠压保护',
        motor_pole_pair_count: '电机极对数',
        reverse_charge_current: '反向充电电流设置',

        chem_id: "电芯型号",
        system_error_status: '错误计数',
        cell_voltage: '电芯电压',
        cell_voltage_1: '电芯电压 1',
        cell_voltage_2: '电芯电压 2',
        history: '电池最值记录',
        frame_type: '帧类型',
        timestamp: '时间戳',
        packet_id: '包流水号',
        bms_time: 'BMS时间',

        software_version: '软件版本',
        hardware_version: '硬件版本',
        firmware_index_code: '固件索引码',

        maximum_discharge_current: '最大放电电流',
        maximum_charging_current: '最大充电电流',
        maximum_cell_voltage: '最大电芯电压',
        minimum_cell_voltage: '最小电芯电压',
        maximum_battery_pack_temperature: '电池包最大温度',
        minimum_battery_pack_temperature: '电池包最小温度',

        ota_type: 'OTA任务类型',
        ota_error_code: 'OTA错误码',
        ota_state_code: 'OTA状态码',

        protocol_version: "协议版本",
        signal_strength: "信号强度",
        satellite_count: "卫星数量",        
        mileage_curr: "当前里程数",
        mileage_total: "总里程",
        mileage_endurance: "里程耐力",
        battery_power: "电池电量",
        lock_status: "锁定状态",
        boot_status: "启动状态",
        ecu_battery: "车载电脑电池",
        ecu_gps_status: "车载电脑GPS状态",
        last_status_report_time: "上次上报时间",

        battery_soh: "SOH",                    
        battery_status: "电池状态",                    
        battery_current_threshold: "电池电流阈值",                    
        battery_charge_count: "电池充电次数",
        battery_discharge_count: "电池放电次数",
        battery_cell_voltage: "蓄电池电压",

        remaining_mileage: "剩余里程",         
        torque: "扭矩",
        mcu_temperature: "MCU温度",
        mcu_engine_temperature: "MCU电机温度",
        mcu_status: "MCU状态",
        gear: "档位",
        reverse_energy_recovery: "反向动能回收",

        vcu_base_info: "VCU基本信息",
        mcu_base_info: "MCU基本信息",
        hmi_base_info: "HMI基本信息",
        charger_base_info: "充电器基本信息",
        hardware_version_number: "硬件版本号",
        software_version_number: "软件版本号",
        vendor: "制造商代号",
        Battery: "电池",
    },
    // 数据帧
    frame: {
        original_data: '原始数据',
        frame_data: '帧数据',

        illegal_data_packet: '非法数据包',

        charge_status: {
            not_charging: '未充电',
            charging: '充电',
            fully_charged: '充满',
            time_is_up: '时间满',
        },
        overload: '过载',
        overcurrent: '过流',
        overtemperature: '过温',
        no_load: '空载',
        electric_meter_failure: '电表故障',
        metering_circuit_fault: '计量电路故障',
        electric_leakage: '漏电',
        cp_status_is_abnormal: 'CP状态异常',
        charging_gun_insertion: '充电枪插入',

        login: '登录',
        vehicle_status: '车辆状态',
        node: '节点',
        port: '孔',
        failure: '失败',
        success: '成功',

        type: {
            login: '登录',
            authentication: '认证',
            warning:'告警',
            escalation:'上报',
            heartbeat: '心跳',

            login_success : '登录成功',
            receive_success: '接收成功',
            get_data : '获取数据',
            remote_control  : '远程控制',

            request_access: '请求入网',
            request_update_session_key: '请求更新SessionKey',
            up_link_data: '上行数据',
            report_fota_version: '上报固件版本号',
            response_ota_task: '回复OTA升级任务',
            request_down_fota_data: '请求下载固件数据',
            notification_upgrade_result: '升级结果通知',
        },

        valid: '有效',
        invalid: '无效',

        device_status: {
            '0_0': 'USB输出(RW)',
            '0_1': '尾灯(RW)',
            '0_2': '充电器识别状态(RO)',
            '0_3': '充电器连接状态(RO) ',
            '0_4': '预充电路(RW)',
            '0_5': '预放电路(RW)',
            '0_6': '放电MOS(RW)',
            '0_7': '充电MOS(RW)',

            '1_7': '电池停止充电状态',

            '2_0': '保护IC出错',
            '2_1': '电芯掉线 ',
            '2_2': '电芯不平衡',
            '2_3': '计量出错',
            '2_4': '记录出错',
            '2_5': '时钟出错',
            '2_6': '放电MOS损坏',
            '2_7': '充电MOS损坏',

            '3_0': '过充错误',
            '3_1': '初级过放',
            '3_2': '二级过放错误',
            '3_3': '初级过流',
            '3_4': '二级过流',
            '3_5': '充电过流',
            '3_6': '软启动失败',
            '3_7': '预充超时警告',

            '4_0': 'MOS温度传感器故障',
            '4_1': '电芯温度传感器故障',
            '4_2': '放电过温',
            '4_3': '充电过温',
            '4_4': '放电欠温',
            '4_5': '充电欠温',
            '4_6': '放电MOS过温',
            '4_7': '充电MOS过温',

            '5_0': '软启动电路过温',
            '5_4': '三级过流',
            '5_6': '配置错误',

            '6_0': '保护IC出错',
            '6_1': '电芯掉线',
            '6_2': '电芯不平衡',
            '6_3': '计量出错',
            '6_4': '记录出错',
            '6_5': '时钟出错',
            '6_6': '放电MOS损坏',
            '6_7': '充电MOS损坏',

            '7_0': '过充错误',
            '7_1': '初级过放',
            '7_2': '二级过放错误',
            '7_3': '初级过流',
            '7_4': '二级过流',
            '7_5': '充电过流',
            '7_6': '软启动失败',
            '7_7': '预充超时警告',

            '8':  '电池剩余容量百分比',
            '9':  '电池健康状态百分比',
            '10': '电池包总电压',
            '14': '实时电流',
            '18': '实时电芯最高温度',
            '19': '实时电芯最低温度',
            '20': '实时Mos管温度',
            '21': '其他温度',
            '22': '允许最大充电电流',
            '23': '放电信息',
            '24': '电池循环次数',
        },
        real_time: "实时",
        lately: "最近",

    },
    // 事件
    event: {
        report_time: '上报时间',
        report_type: '上报类型',
        event_type: '事件类型',
        type: {
            connect: '连接',
            break: '断开',
        },
    },
    // 命令
    command: {
        status: {
            wait:    "等待中",
            issued:  "已下发",
            respond: "已回应",
            failure: "已失败",
        },
        type: {
            '0x01': '下发配置',
            '0x02': '获取节点状态',
            '0x03': '获取节点配置',
            '0x04': '设置参数',
            '0x05': '设置插座系统参数',
            '0x06': '控制',
            '0x07': '组网',
            '0x08': '添加节点',
            '0x09': '删除节点',
            '0x0A': '升级',
            '0x0B': '刷卡充电控制',
            '0x0C': '查询刷卡余额回应',
            '0x0D': '设置语音播报配置',
            '0x31': '刷卡充电开始回应',
            '0x32': '刷卡充电结束回应',
        },

        request_id: '请求ID',
        request_type: '请求类型',
        request_time: '请求时间',
        request_data: '请求数据',
        request_data_type: {
            plug_heartbeat: "插座心跳",
            charge_finished: "充电结束",
            gateway_heartbeat: "网关心跳",
            plug_mp_heartbeat: "多口插座心跳",
            charge_finished_3: "分功率充电结束",
            card_charge_started: "刷卡充电开始",
            card_charge_finished: "刷卡充电结束",
        },

        response_time: '回应时间',
        response_data: '回应数据',
        response_empty: '暂无回应数据',

        elapsed_time: '耗时',

        notify_url: '推送地址',
        retry_count: '推送次数',

        "26001": {
            GET_GPS: '获取GPS数据',
            GET_STATUS: '获取⻋辆状态',
            GET_BMS: '获取BMS信息',
            CHECK_VEHICLE: '⻋辆检测',
            CHECK_BMS: 'BMS检测',
            CHECK_METER: '仪表检测',
            CHECK_ECU: 'ECU检测',
            CHECK_CONTROLLER: '控制器检测',
            LOCK: '设防',
            UNLOCK: '解防',
            UNLOCK_SEAT: '开坐垫锁',
            UNLOCK_TAIL_BOX: '打开尾箱',
            BOOT: '启动⻋辆',
            SHUTDOWN: '关闭⻋辆',
            REBOOT: '远程重启硬件',
        },
        "26003": {
            launch: '设置车辆点火/熄火',
                turn_on: '点火',
                turn_off: '熄火',
            reboot: '重启',
            check: '检测',

            getGsmGpsStatus: '查询GSM/GPS状态',
            getLocation: '获取位置',
            getHistoryLocation: '获取历史位置',
            getBattery: '获取电池状态',

            setBMS: '设置BMS信息',
                please_input_index: '请设置index',
                please_input_bms_info: '请设置BMS信息',
                please_input_time_out_period: '请设置超时时间',

            setServerAddr: '设置服务端地址',

            getGuard: '获取设防状态',
            setGuard: '设置设防状态',
                defenses: '设防',
                no_defenses: '不设防',

            getLock: '获取锁状态',
            setLock: '设置设防状态',
                lock: '加锁',
                unlock: '解锁',

            getHeartbeatInterval: '获取心跳间隔',
            setHeartbeatInterval: '设置心跳间隔',

            getAPN: '获取APN',
            setAPN: '设置APN',

            getLocateInterval: '获取定位周期',
            setLocateInterval: '设置定位周期',
            please_input_acc_on_interval: '请设置ACC ON上报频率',
            please_input_acc_off_interval: '请设置ACC OFF上报频率',
            getModuleInfo: '获取部件信息',
            getMileage: '获取里程',

            setHmiParams: '设置HMI参数',
            setBmsParams: '设置BMS参数',
            setMcuParams: '设置MCU参数',
        },
        "26004": {},
        "26005": {
            getInfo1: '获取数据1',
            getInfo2: '获取数据2',
            getInfo3: '获取数据3',

            set_gprs_apn: "设置GPRS APN",

            set_bluetooth_password: '设置蓝牙连接密码',

            set_module_access_parameters: '设置模块接入参数',
                set_server_addr: '设置服务端地址',
                set_OM_server_addr: '设置运维服务器地址',

            activate_module_upgrade: '激活模块升级',
                module_upgrade: '模块升级',
                bms_upgrade: 'BMS升级',

            set_battery: '配置电池',
                usb_power: 'USB输出(RW)',
                light_status: '尾灯(RW)',
                charger_indentify_status: '充电器识别状态(RO)',
                charger_connection: '充电器连接状态(RO)',
                pre_charge_circuit: '预充电路(RO)',
                pre_discharge_circuit: '预放电路(RO)',
                discharge_mosfet: '放电 MOS (RW)',
                charge_mosfet: '充电 MOS(RW)',
                battery_charging_stopped_flag: '电池停止充电状态',

            set_electronic_fence: '设置电子围栏',
                fence_radius: '围栏半径',
        },
        "26006": {
            getInfo1: '获取数据1',
            getInfo2: '获取数据2',
            getInfo3: '获取数据3',

            set_gprs_apn: "设置GPRS APN",

            set_bluetooth_password: '设置蓝牙连接密码',

            set_module_access_parameters: '设置模块接入参数',
                set_server_addr: '设置服务端地址',
                set_OM_server_addr: '设置运维服务器地址',

            activate_module_upgrade: '激活模块升级',
                module_upgrade: '模块升级',
                bms_upgrade: 'BMS升级',

            set_battery: '配置电池',
                usb_power: 'USB输出(RW)',
                light_status: '尾灯(RW)',
                charger_indentify_status: '充电器识别状态(RO)',
                charger_connection: '充电器连接状态(RO)',
                pre_charge_circuit: '预充电路(RO)',
                pre_discharge_circuit: '预放电路(RO)',
                discharge_mosfet: '放电 MOS (RW)',
                charge_mosfet: '充电 MOS(RW)',
                battery_charging_stopped_flag: '电池停止充电状态',

            set_electronic_fence: '设置电子围栏',
                fence_radius: '围栏半径',
        },

        "26007": {
            
        },
        custom_read: '自定义读取操作',
    },


    // OTA
    task: {
        status: {
            init: '初始化',
            upgrading: '升级中',
            paused: '暂停',
            finish: '完成',
            stop: '停止',
        },
        member_status: {
            init: '初始化',
            in_preparation: '准备中',
            upgrading: '升级中',
            success: '成功',
            failure: '失败',
            fail_in_get_file: '获取升级文件信息失败',
            fail_in_set_file: '本地暂存升级文件失败',
            fail_in_get_data: '获取分片数据失败',
        },
        upgrade_status: {
            leisure: '空闲',
            upgrading: '升级中',
        },

        ask_delete: '确定要删除该任务吗？',
        ask_remove_member: '确定要将设备移出本任务吗？',

        task_name: '任务名称',
        task_status: '任务状态',
        target_version: '目标版本',
        target_version_code:'目标版本号',

        plan: '计划',
        plan_time: '计划执行时间',

        processing_count: '升级中设备数',
        success_count: '成功设备数',
        total_count: '总设备数',
        success_total_count: '成功数/总数',

        upload_file: '上传升级文件',
        file_qrcode: '任务二维码',
        pack_size: '每包文件大小',
        pack_wait: '每包时间间隔',

        add_member: '添加升级设备',
        import_member: '导入升级设备',
        task_member: '任务成员',
        member_list: '成员列表',

        progress: '进度',
        curr_version: '当前版本',
        send_success: '指令发送成功',
        download_template: '下载模板',
        download_failure: '下载失败',
        download_success: '下载成功',
    },
    file: {
        name: '文件名',
        version: '版本号',
        hash: '文件Hash',
        size: '文件大小',
        upload: '上传文件',
        select: '选择文件',
    },

    // 工具
    tool: {
        unpack_result: '解码内容'
    },

    // OTA参数
    OTA: {
        ota_data_length: "数据长度",
        ota_data_offset: "数据偏移量",       
        ota_type: "OTA任务类型",
            transfer_confirmation : "升级传输/确认",
            fragment_transmission: "数据分片传输",
            Transmission_complete: "传输完成",
        ota_state_code: "升级结果",
            upgrade_successfully:"升级成功",
            upgrade_failure:"升级失败",
            file_check_error:"文件校验错误",
            firmware_version:"固件版本已为最新",
    }
}